module.exports = __webpack_public_path__ + "img/blank-avatar.5c411184.png";